module.exports = __webpack_public_path__ + "img/Sib_Mus_5kl.dc5be828.jpg";